import { Amplify } from 'aws-amplify';
import { runtimeConfig, validateRuntimeConfig } from './runtime';

function buildLoginWith(): {
  email?: true;
  username?: true;
  phone?: true;
} {
  switch (runtimeConfig.loginMechanism) {
    case 'username':
      return { username: true };
    case 'phone_number':
      return { phone: true };
    case 'email':
    default:
      return { email: true };
  }
}

export function configureAws(): void {
  validateRuntimeConfig();

  if (runtimeConfig.authMode !== 'cognito') {
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: runtimeConfig.userPoolId,
        userPoolClientId: runtimeConfig.userPoolClientId,
        identityPoolId: runtimeConfig.identityPoolId,
        loginWith: buildLoginWith(),
        allowGuestAccess: false,
      },
    },
    Storage: {
      S3: {
        bucket: runtimeConfig.s3Bucket,
        region: runtimeConfig.s3Region,
      },
    },
  });
}
